import { TemplateElement, html, defineElement } from '@webtides/element-js';

export default class VideoControls extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    connected() {
        this.video = document.querySelector(this.selector);
        this.removeAttribute('cloak');
    }

    properties() {
        return {
            selector: '',
            isPlay: true,
            video: '',
        };
    }

    events() {
        return {
            '[data-video-controls]': {
                click: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.videoControl();
                },
            },
        };
    }

    videoControl() {
        if (this.isPlay) {
            this.video.pause();
            this.isPlay = false;
        } else {
            this.video.play();
            this.isPlay = true;
        }
    }

    template() {
        return html`
            <div
                data-video-controls
                id="stage-video-control"
                class="relative z-10 ml-auto mr-3 mt-3 max-w-max cursor-pointer rounded
                    bg-black bg-opacity-24 px-2 py-1 transition-all"
            >
                ${this.isPlay ? 'Pause' : 'Play'}
            </div>
        `;
    }
}

export function define() {
    defineElement('video-controls', VideoControls);
}
